import logo from './headphones.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <br />
        <br />
        <p>
          Vanilla Coding 13th - Team TTT
        </p>
        <a
          className="App-link"
          href="https://www.ttt-circle.online/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Welcome to Circle!
        </a>
      </header>
    </div>
  );
}

export default App;
